


























































































import { Vue, Component } from "vue-property-decorator";
import api, { categoryApi } from "@/getinfo-api";
import { Category as ICategory } from "@/api/models/category";
import CategoryItem from "@/components/category/CategoryItem.vue";
import { CategoryList as ICategoryList } from "@/api/models/category-list";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import { getCurrentCompanyId } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, CategoryItem }
})
export default class CategoryList extends Vue {
  title!: string;
  description!: string;
  categoriesList: Array<ICategory> = [];
  limit: number = 300;
  offset: number = 0;
  showSpinner: boolean = false;
  categoryCount: number = 0;
  search: string = "";
  data() {
    return {
      title: undefined,
      description: undefined
    };
  }

  updateCategoriesList(categoryId: string) {
    this.categoriesList = this.categoriesList.filter(
      el => el.id !== categoryId
    );
    this.categoryCount -= 1;
  }

  getCategoryByOffset() {
    this.offset += this.limit;
    this.getAllCategories(this.offset);
  }

  clearCategories() {
    this.categoriesList = [];
    this.offset = 0;
    this.search = "";
    this.getAllCategories();
  }

  submitSearch() {
    this.categoriesList = [];
    this.offset = 0;
    this.getAllCategories();
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  getAllCategories(offset: number = 0) {
    this.showSpinner = true;
    let params: CategoriesListParams = {
      title: this.search,
      companyId: this.companyId,
      limit: this.limit,
      offset: offset
    };
    categories(params)
      .then((res: { data: ICategoryList }) => {
        this.categoryCount = res.data.count;
        if (res.data.items) {
          res.data.items.forEach((item: ICategory) => {
            this.categoriesList.push(item);
          });
        }
      })
      .finally(() => {
        this.showSpinner = false;
      })

      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.getAllCategories();
  }

  get screenWidth() {
    return window.innerWidth;
  }
}
